import React, { useState, useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "assets/imgs/Logo-Principal-Brancopng.png";
import InputText from "components/_base/InputText";
import InputPassword from "components/_base/InputPassword";
import Button from "components/_base/Button";
import { Context } from "context/AuthContext";
import "./styles.scss";
import { useNavigate } from "react-router-dom";

const ContentLogin = () => {
  const navigate = useNavigate();
  const params = new URLSearchParams(useLocation().search);

  const { showLoader, handleLogin } = useContext(Context);

  const [erroLogin, setErroLogin] = useState({
    authenticated: false,
    error: "",
  });
  const [formData, setFormData] = useState({
    username: "",
    password: "",
    redirect: params.get("urlReturn") ? params.get("urlReturn") : "/",
  });

  const onChangeIput = (e) => {
    const { value, name } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const submitLogin = async (e) => {
    e.preventDefault();
    const resposnse = await handleLogin(formData);
    setErroLogin((prevState) => ({
      ...prevState,
      authenticated: resposnse.authenticated,
      error: resposnse.error,
    }));
  };

  return (
    <div className="content-wrapper">
      <div className="login-container">
        <div className="left-box-login">
          <img className="img-logo" src={logo} alt="Logo" />
        </div>
        <div className="right-box-login">
          <h1 className="text-shadow">Login</h1>
          {!erroLogin.authenticated && (
            <p className="msg-error">{erroLogin.error}</p>
          )}
          <InputText
            className="small-placeholder"
            name="username"
            value={formData.user}
            onChange={onChangeIput}
            placeholder="Email"
          />
          <InputPassword
            className="small-placeholder"
            name="password"
            value={formData.password}
            onChange={onChangeIput}
            placeholder="Senha"
          />
          <Link to="/redefinir-senha" className="recuperacao-senha">
            Esqueci minha senha
          </Link>

          <Button className={"btn-login"} onClick={submitLogin}>
            Entrar
          </Button>
          <p>ou</p>
          <Button light onClick={() => navigate("/cadastrar-usuario")}>
            Registrar
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ContentLogin;
